import { createApp } from 'vue';
import App from './App.vue';
import router, { setI18nInstance } from './router';
import { createI18n } from 'vue-i18n';
// 翻訳データを直接インポート
import tickets from '@/locales/Tickets.js';
import faqQuestions from '@/locales/FaqQuestions.js';
import contentsMain from '@/locales/ContentsMain.js';
import setTickets from '@/locales/SetTickets.js';
import collaboRation from '@/locales/CollaboRation.js';
import areaMap from '@/locales/AreaMap.js';
import credit from '@/locales/Credit.js';
import footer from '@/locales/Footer.js';
import header from '@/locales/Header.js';
import heroImage from '@/locales/HeroImage.js';
import mainHeading from '@/locales/MainHeading.js';
import otherEvents from '@/locales/OtherEvents.js';
import foodMenu from '@/locales/FoodMenu.js';
import bannerBlock from '@/locales/BannerBlock.js';
import announcement from '@/locales/Announcement.js';
import inforMation from '@/locales/InforMation.js';
import tickets2 from '@/locales/Tickets2.js';

// 翻訳データをマージ
const messages = {
  ja: {
    ...tickets.ja,
    ...faqQuestions.ja,
    ...contentsMain.ja,
    ...setTickets.ja,
    ...collaboRation.ja,
    ...areaMap.ja,
    ...credit.ja,
    ...footer.ja,
    ...header.ja,
    ...heroImage.ja,
    ...mainHeading.ja,
    ...otherEvents.ja,
    ...foodMenu.ja,
    ...bannerBlock.ja,
    ...announcement.ja,
    ...inforMation.ja,
    ...tickets2.ja,
  },
  en: {
    ...tickets.en,
    ...faqQuestions.en,
    ...contentsMain.en,
    ...setTickets.en,
    ...collaboRation.en,
    ...faqQuestions.en,
    ...areaMap.en,
    ...credit.en,
    ...footer.en,
    ...header.en,
    ...heroImage.en,
    ...mainHeading.en,
    ...otherEvents.en,
    ...foodMenu.en,
    ...bannerBlock.en,
    ...announcement.en,
    ...inforMation.en,
    ...tickets2.en,
  },

};
import VueSmoothScroll from 'vue3-smooth-scroll'
import SvgIcon from '@jamescoyle/vue-icon'


// サポートされている言語とvue-i18nの言語コードマッピング
const supportedLangs = ['ja', 'en'];
const vueI18nLangs = {};
const defaultLang = 'ja';

// 初期言語を日本語に固定
const initialLang = 'ja';

const i18n = createI18n({
legacy: false,
locale: initialLang, // 初期の言語を設定
fallbackLocale: 'ja',
messages,
globalInjection: true,
missingWarn: false,
fallbackWarn: false
});

// コンソールに言語設定を出力
console.log("ブラウザの優先言語リスト:", navigator.languages);
console.log("選択された初期言語:", initialLang);
console.log("messages:", messages);
console.log("locale settings:", {
locale: initialLang,
fallbackLocale: 'ja',
messages
});
console.log("messages[zhTW]:", messages.zhTW);
console.log("messages[zhCN]:", messages.zhCN);


// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'myTheme',
    themes: {
      myTheme: {
        dark: true,
        colors: {
          primary: '#00738F', 
          secondary: '#00738F', 
          note: '#8D8D8D',
          accent: '#8c9eff', 
          error: '#b71c1c', 
          'on-primary': '#ffffff',
          background: '#0B0B0B',
        },
      }
    },
  },
});

const app = createApp(App);
app.use(router);
app.use(i18n);
app.use(vuetify);
app.component('SvgIcon', SvgIcon);

// ルーターにi18nインスタンスを設定
setI18nInstance(i18n);

app.use(VueSmoothScroll, {
  duration: 500,       // スクロールアニメーションの継続時間（ミリ秒）
  offset: -50,         // スクロール位置のオフセット（ピクセル）
  updateHistory: true  // ハッシュを履歴に追加するかどうか
});

app.mount('#app'); // アプリケーションをマウント

export { i18n }; // i18nをエクスポート